export default "__VITE_ASSET__CQAClpOQ__"